const number = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
};

export function salesFor(item, period) {
  const services = {
    amount: number(item?.[period]?.services?.amount),
    count: number(item?.[period]?.services?.count),
  };
  const reservations = {
    amount: number(item?.[period]?.reservations?.amount),
    count: number(item?.[period]?.reservations?.count),
  };
  return {
    services,
    reservations,
    total: {
      amount: services.amount + reservations.amount,
      count: services.count + reservations.count,
    },
  };
}

export function sumSales(items, period) {
  return items.reduce((sum, item) => {
    const stats = salesFor(item, period);
    for (const key of ["services", "reservations", "total"]) {
      sum[key].amount += stats[key].amount;
      sum[key].count += stats[key].count;
    }
    return sum;
  }, salesFor(null, period));
}

export function monthlyLeaderboard(items) {
  const ranked = items
    .filter((item) => Number(item.support_id) > 0)
    .map((item) => ({ ...item, sales: salesFor(item, "month") }))
    .filter((item) => item.sales.total.amount > 0)
    .sort((a, b) => b.sales.total.amount - a.sales.total.amount || Number(a.support_id) - Number(b.support_id));

  let rank = 0;
  return ranked.map((item, index) => {
    if (index === 0 || item.sales.total.amount !== ranked[index - 1].sales.total.amount) {
      rank = index + 1;
    }
    return { ...item, rank };
  });
}
